<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<ng-template>
  <div class="content position-relative">
    <div class="scrollable">
        <ng-content></ng-content>
    </div>
    <div class="footer">
      <ng-content select="[wellWizardTabFooter]"></ng-content>
    </div>
  </div>
</ng-template>




